export default {
  zh: {
    organisitionChart: '部门管理',
    inputDeaprmentPlaceHolder: '请在此输入新建部门名',
    addNewTip: '添加新部门到',
    editStructure: '编辑部门顺序',
    chooseDepartment: '选择部门',
    chooseDepartmentTip: '点击部门选择目标部门',
    chooseDepartmentSubTitle: '将{user}从{department}移动到',
    chooseSameDeparment: '原部门和目标部门一致，请重新选择',
  },
  en: {
    organisitionChart: 'Organization Chart',
    inputDeaprmentPlaceHolder: 'Input department name here',
    addNewTip: 'Addd New Department to',
    editStructure: 'Edit Structure',
    chooseDepartment: 'Choose Department',
    chooseDepartmentTip: 'Click heading to choose the target department',
    chooseDepartmentSubTitle: 'Move {user} from {department} to',
    chooseSameDeparment: 'Source department and target department is same，please reselect',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/OrganisationChart/i18n.js